import React from 'react';
import { Button, Modal, ModalProps } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form, Formik } from 'formik';
import { number, object } from 'yup';
import { useSelector } from 'react-redux';

import { FrontlineUserFormGroupSelect } from '@components/Feature/User';
import { ServerError } from '@components/Helper';

import { CollaborationCreatePayload } from './action';
import { selectFeatureCollaboration } from './selector';

export type CollaborationFormValues = Pick<CollaborationCreatePayload, 'collaboratorId'>;

type FormFormProps = Pick<ModalProps, 'onHide'>;

const FormForm = ({ onHide }: FormFormProps) => {
  const { t } = useTranslation();
  const { serverErrors } = useSelector(selectFeatureCollaboration);

  return (
    <Form>
      <Modal.Header closeButton>
        <Modal.Title>Add Collaborator</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FrontlineUserFormGroupSelect
          asRow
          label="Collaborator"
          name="collaboratorId"
          groupProps={{ className: 'mb-3' }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('confirmModal.cancel')}
        </Button>
        <Button type="submit" variant="primary">
          {t('common:save')}
        </Button>
      </Modal.Footer>
      <ServerError errors={serverErrors} />
    </Form>
  );
}

type Props = ModalProps & {
  onSubmit: (values: CollaborationFormValues) => void;
}

const CollaborationFormModal = ({ onSubmit, ...props }: Props) => {
  const { t } = useTranslation();

  const validationSchema = object({
    collaboratorId: number().required(t('validation:required')),
  });

  const initialValues: CollaborationFormValues = {
    collaboratorId: '',
  };

  return (
    <Modal {...props}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <FormForm onHide={props.onHide} />
      </Formik>
    </Modal>
  )
};

export { CollaborationFormModal };
